import CardContentSection from './cardContentSection.js';
export default CardContentSection;
